import * as VueRouter from 'vue-router'
import Home from './pages/Home.vue'
import Page from './pages/Page.vue'
import NotFound from './pages/NotFound.vue'

const routes = [
  { path: '/', component: Home },
  { path: '/alarm-manager', component: Page },
  { path: '/:pathMatch(.*)*', component: NotFound },
]

const router = VueRouter.createRouter({
  history: VueRouter.createWebHashHistory(),
  routes,
  sensitive: true,
})

export default router